import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
export const PaginationPageButton = ({ page, onPageButtonClick, pagination }) => {
    return (_jsx("button", { className: cn('store-pagination__page-button', {
            'store-pagination__page-button--active': pagination.currentPage === page,
        }), onClick: onPageButtonClick(page), children: page }));
};
